import React, { useState } from "react";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Offer from "@/components/sections/Offer";
import WhyUs from "@/components/sections/WhyUs";
import Gallery from "@/components/sections/Gallery";
import Testimonials from "@/components/sections/Testimonials";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import QuoteDialog from "@/components/sections/QuoteDialog";

export default function Home() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const openQuote = () => setQuoteOpen(true);
  const closeQuote = () => setQuoteOpen(false);

  return (
    <main data-testid="home-page" className="bg-[#050505] text-white">
      <Navbar onOpenQuote={openQuote} />
      <Hero onOpenQuote={openQuote} />
      <About />
      <Offer onOpenQuote={openQuote} />
      <WhyUs />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
      <QuoteDialog open={quoteOpen} onClose={closeQuote} />
    </main>
  );
}
